var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5012 6c-.8279 0-1.5.672-1.5 1.5v2.59l-1-.136v-5.454c0-.828-.6719-1.5-1.4999-1.5s-1.5.672-1.5 1.5v5.045l-1-.136v-5.909c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5v5.5h-1.00005v-4.5c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5v8.564l-.186-.186c-1.172-1.172-3.071-1.172-4.243 0l-.279.279c-.391.391-.391 1.024 0 1.414l5.641 5.641.141-.141c.608.572 1.42.929 2.321.929h7.60495c2.209 0 4-1.791 4-4v-9.5c0-.828-.672-1.5-1.5-1.5z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 19c-.386 0-12.614 0-13 0-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h13c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.3a6822d8b0adcdabbc1b09adbd75ab34.svg";
export { ForwardRef as ReactComponent };